import React, { useEffect } from 'react';
import { Helmet } from "react-helmet-async";
import lib from '../../assets/images/library/library.png';
import lib2 from '../../assets/images/library/lib2.png';
import lib3 from '../../assets/images/library/lib3.png';
import { BookOpen, Newspaper, Users, Phone, Mail, CheckCircle2, ShieldAlert, Sparkles, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';


export default function AboutLibrary() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>About the Library - Vidyajyoti College of Theology - Delhi</title>
        <meta name="description" content="Vidyajyoti Library housing over 1,34,000 volumes and 228 national & international journals in theology, philosophy, and religion." />
        <meta name="keywords" content="Vidyajyoti Library, Theology library Delhi, Catholic research library, Christian books Delhi" />
        <link rel="canonical" href="/library/about" />
      </Helmet>

      <div className="py-5" style={{ background: '#f8fafc', minHeight: '100vh' }}>
        <div className="container">
          {/* Header Banner */}
          <div className="text-center mx-auto pb-4" style={{ maxWidth: '800px' }}>
            <div className="d-inline-flex align-items-center gap-2 px-3 py-1 rounded-pill mb-3" style={{ background: 'rgba(26, 43, 86, 0.08)', color: '#1a2b56', fontSize: '0.85rem', fontWeight: 600, border: '1px solid rgba(26, 43, 86, 0.2)' }}>
              <Sparkles size={14} /> Premier Research Repository
            </div>
            <h1 className="display-6 fw-bold mb-3" style={{ color: '#1a2b56', fontFamily: "'Outfit', sans-serif" }}>
              Vidyajyoti Central Library
            </h1>
            <p className="lead text-muted" style={{ fontSize: '1.05rem', lineHeight: '1.7' }}>
              One of the premier theological repositories in South Asia, supporting scholarly inquiry, postgraduate research, and inter-religious studies for students, faculty, and visiting scholars.
            </p>
          </div>

          {/* Key Stats Counter Bar */}
          <div className="row g-4 mb-5">
            <div className="col-md-4">
              <div className="card h-100 border-0 rounded-4 shadow-sm p-4 text-center bg-white" style={{ borderTop: '4px solid #1a2b56' }}>
                <div className="d-inline-flex p-3 rounded-circle mb-3 mx-auto" style={{ background: 'rgba(26, 43, 86, 0.08)', color: '#1a2b56' }}>
                  <BookOpen size={28} />
                </div>
                <h2 className="display-6 fw-bold mb-1" style={{ color: '#1a2b56' }}>1,34,000+</h2>
                <h6 className="fw-semibold text-dark mb-1">Cataloged Volumes</h6>
                <p className="text-muted small mb-0">Rare manuscripts, biblical commentaries, theology texts &amp; encyclopedias.</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card h-100 border-0 rounded-4 shadow-sm p-4 text-center bg-white" style={{ borderTop: '4px solid #c69214' }}>
                <div className="d-inline-flex p-3 rounded-circle mb-3 mx-auto" style={{ background: 'rgba(198, 146, 20, 0.12)', color: '#c69214' }}>
                  <Newspaper size={28} />
                </div>
                <h2 className="display-6 fw-bold mb-1" style={{ color: '#c69214' }}>228+</h2>
                <h6 className="fw-semibold text-dark mb-1">Subscribed Journals</h6>
                <p className="text-muted small mb-0">National and international peer-reviewed academic periodicals.</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card h-100 border-0 rounded-4 shadow-sm p-4 text-center bg-white" style={{ borderTop: '4px solid #79031d' }}>
                <div className="d-inline-flex p-3 rounded-circle mb-3 mx-auto" style={{ background: 'rgba(121, 3, 29, 0.08)', color: '#79031d' }}>
                  <Users size={28} />
                </div>
                <h2 className="display-6 fw-bold mb-1" style={{ color: '#79031d' }}>Scholarly Hub</h2>
                <h6 className="fw-semibold text-dark mb-1">Inter-University Access</h6>
                <p className="text-muted small mb-0">Open to researchers from JNU, DU, Jamia Millia &amp; global institutions.</p>
              </div>
            </div>
          </div>

          {/* Visual Showcase & About Section */}
          <div className="card border-0 rounded-4 shadow-sm p-4 p-md-5 bg-white mb-5">
            <div className="row align-items-center g-4">
              <div className="col-lg-6">
                <span className="badge px-3 py-1 rounded-pill mb-2" style={{ background: '#1a2b56', color: '#fff' }}>Collection Overview</span>
                <h3 className="fw-bold mb-3" style={{ color: '#1a2b56' }}>Dedicated to Intellectual &amp; Spiritual Formation</h3>
                <p className="text-muted" style={{ lineHeight: '1.8', textAlign: 'justify' }}>
                  The Vidyajyoti Central Library serves as the intellectual engine of the faculty. Its comprehensive collection covers Biblical Studies, Contextual Theology, Comparative Religions, Indology, Moral Theology, Canon Law, Church History, and Human Rights.
                </p>
                <p className="text-muted" style={{ lineHeight: '1.8', textAlign: 'justify' }}>
                  In addition to our residential students and faculty, researchers and Ph.D. scholars from premier universities across India and abroad frequently utilize our dedicated reading rooms and rare reference collections.
                </p>
                <div className="pt-2">
                  <Link to="/library/latest" className="btn px-4 py-2.5 rounded-pill fw-semibold text-white shadow-sm" style={{ background: '#79031d' }}>
                    Browse Latest Arrivals <ExternalLink size={14} className="ms-1" />
                  </Link>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="rounded-4 overflow-hidden shadow-sm" style={{ height: '340px' }}>
                  <img src={lib3} className="w-100 h-100" alt="Vidyajyoti Central Library Reading Room" style={{ objectFit: 'cover' }} />
                </div>
              </div>
            </div>
          </div>

          {/* Terms for External Researchers */}
          <div className="card border-0 rounded-4 shadow-sm p-4 p-md-5 bg-white mb-5">
            <div className="row g-4 align-items-center">
              <div className="col-lg-7">
                <div className="d-flex align-items-center gap-2 mb-3">
                  <ShieldAlert size={22} style={{ color: '#79031d' }} />
                  <h4 className="fw-bold mb-0" style={{ color: '#1a2b56' }}>Guidelines for External Scholars &amp; Students</h4>
                </div>
                <p className="text-muted small mb-4">
                  External research scholars desiring reference access to the Vidyajyoti College Library are requested to adhere to the following protocol:
                </p>

                <ul className="list-unstyled d-flex flex-column gap-2.5 mb-0">
                  {[
                    "An official recommendation letter from your research guide on university letterhead requesting access.",
                    "Photocopy of university identity card, Aadhaar card/passport, and proof of local residence with contact details.",
                    "A signed declaration stating the academic purpose and commitment to submit bibliographic citations of resulting publications.",
                    "External scholars may utilize books in the Reference Room on a daily basis (no outside borrowing).",
                    "Access to archival and rare manuscripts requires special prior permission from the Chief Librarian.",
                    "Prescribed nominal library maintenance fee: ₹100 / month or ₹500 / year."
                  ].map((text, i) => (
                    <li key={i} className="d-flex align-items-start gap-2">
                      <CheckCircle2 size={16} className="text-success flex-shrink-0 mt-1" />
                      <span className="text-muted small" style={{ lineHeight: '1.5' }}>{text}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="col-lg-5">
                <div className="row g-3">
                  <div className="col-12">
                    <div className="rounded-4 overflow-hidden shadow-sm" style={{ height: '170px' }}>
                      <img src={lib2} className="w-100 h-100" alt="Vidyajyoti Library Stacks" style={{ objectFit: 'cover' }} />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="rounded-4 overflow-hidden shadow-sm" style={{ height: '170px' }}>
                      <img src={lib} className="w-100 h-100" alt="Vidyajyoti Library Study Area" style={{ objectFit: 'cover' }} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Information */}
          <div className="card border-0 rounded-4 shadow-sm p-4 p-md-5" style={{ background: 'linear-gradient(135deg, rgba(26,43,86,0.04) 0%, rgba(198,146,20,0.06) 100%)', border: '1px solid rgba(26,43,86,0.1)' }}>
            <div className="text-center mx-auto mb-4" style={{ maxWidth: '600px' }}>
              <h4 className="fw-bold" style={{ color: '#1a2b56' }}>Library Helpdesk &amp; Staff</h4>
              <p className="text-muted small mb-0">For catalog inquiries, accession details, and visiting appointments:</p>
            </div>

            <div className="row g-4 justify-content-center">
              <div className="col-md-4">
                <div className="p-4 rounded-4 bg-white shadow-sm h-100 border text-center">
                  <div className="d-inline-flex p-3 rounded-circle mb-3" style={{ background: 'rgba(26, 43, 86, 0.08)', color: '#1a2b56' }}>
                    <Phone size={22} />
                  </div>
                  <h5 className="fw-bold mb-1" style={{ color: '#1a2b56' }}>Sudeep Panna</h5>
                  <p className="text-muted small mb-2">Library Assistant</p>
                  <a href="tel:+919205010207" className="fw-semibold text-decoration-none" style={{ color: '#79031d' }}>
                    (+91) 92050 10207
                  </a>
                </div>
              </div>

              <div className="col-md-4">
                <div className="p-4 rounded-4 bg-white shadow-sm h-100 border text-center">
                  <div className="d-inline-flex p-3 rounded-circle mb-3" style={{ background: 'rgba(198, 146, 20, 0.12)', color: '#c69214' }}>
                    <Phone size={22} />
                  </div>
                  <h5 className="fw-bold mb-1" style={{ color: '#1a2b56' }}>Rohit Varghese</h5>
                  <p className="text-muted small mb-2">Library Technical Staff</p>
                  <a href="tel:+919899626793" className="fw-semibold text-decoration-none" style={{ color: '#79031d' }}>
                    (+91) 98996 26793
                  </a>
                </div>
              </div>

              <div className="col-md-4">
                <div className="p-4 rounded-4 bg-white shadow-sm h-100 border text-center">
                  <div className="d-inline-flex p-3 rounded-circle mb-3" style={{ background: 'rgba(121, 3, 29, 0.08)', color: '#79031d' }}>
                    <Mail size={22} />
                  </div>
                  <h5 className="fw-bold mb-1" style={{ color: '#1a2b56' }}>Librarian Desk</h5>
                  <p className="text-muted small mb-2">General Correspondence</p>
                  <a href="mailto:vidyajyotilibrary@gmail.com" className="fw-semibold text-decoration-none" style={{ color: '#79031d' }}>
                    vidyajyotilibrary@gmail.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
